export function isCodeInRange(codeRange, code) {
    if (codeRange === "0") {
        return true;
    }
    if (codeRange === code.toString()) {
        return true;
    }
    else {
        const codeString = code.toString();
        if (codeString.length != codeRange.length) {
            return false;
        }
        for (let i = 0; i < codeString.length; i++) {
            if (codeRange.charAt(i) != "X" && codeRange.charAt(i) != codeString.charAt(i)) {
                return false;
            }
        }
        return true;
    }
}
export async function retry(fn, n = 1, codesToIgnore = []) {
    const baseDelay = 100;
    for (let i = 0; i < n; i++) {
        try {
            return await fn();
        }
        catch (error) {
            if (error.code && codesToIgnore.includes(error.code)) {
                throw error;
            }
            if (i == n - 1) {
                throw error;
            }
            await new Promise((resolve) => setTimeout(resolve, baseDelay * 2 ** i));
        }
    }
    throw new RangeError("Reached unreachable retry code");
}
